import { useState } from 'react';

import { utilImageLoader } from '@/fo/util/image-loader';

import { styles } from './VideoPlayer.styles';

export interface VideoPlayerProps {
  video: string;
  videoImage?: string;
  title?: string;
}

export function VideoPlayer({ video, videoImage, title }: VideoPlayerProps) {
  const slots = styles();

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div className={slots.base()}>
      <video
        className={slots.video()}
        poster={
          videoImage
            ? utilImageLoader({ src: videoImage, width: 1000 })
            : undefined
        }
        src={utilImageLoader({ src: video, width: 1000 })}
        controls={isHovered}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        title={title}
      />
    </div>
  );
}
